<template>
    <div class="form-group">
      <label v-if="label" style="width: 100%">{{ label }}
        <span v-if="required" style="color: red;"> *</span>
        <span v-if="validation?.$error" style="color: red; padding-left: 10px;">{{ messages }}</span>
      </label>
      <div class="d-flex align-items-center">
          <select class="form-select"
              :class="{ 'is-invalid': validation?.$error }"
              aria-label="Default select example"
              v-model="hour"
              @change="handleSelect"
              :required="required"
              name="hour"
              :disabled="disabled">
              <option v-for="(option, index) in hoursArray" :key="index" :value="option">
                  {{ option }}
              </option>
          </select>

          <span class="mx-2">:</span>
          
          <select class="form-select"
              :class="{ 'is-invalid': validation?.$error }"
              aria-label="Default select example"
              v-model="minute"
              @change="handleSelect"
              :required="required"
              name="minute"
              :disabled="disabled">
              <option v-for="(option, index) in minutesArray" :key="index" :value="option">
                  {{ option }}
              </option>
          </select>
      </div>
    </div>
  </template>
  
  <script setup>
  import { defineEmits, defineProps, onMounted, ref } from 'vue';
  
  const props = defineProps({
    modelValue: {
      type: String,
      default: null,
    },
    placeholder: {
      type: [ String, Boolean ],
      default: '',
    },
    label: {
      type: [ String, Boolean ],
      default: false,
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: [ Object, String ],
      default: () => ({}),
    },
    hoursArray: {
      type: Array,
      default: () => [
        "00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10",
        "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
        "21", "22", "23"
      ],
    },
    minutesArray: {
      type: Array,
      default: () => [
        "00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10",
        "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
        "21", "22", "23", "24", "25", "26", "27", "28", "29", "30",
        "31", "32", "33", "34", "35", "36", "37", "38", "39", "40",
        "41", "42", "43", "44", "45", "46", "47", "48", "49", "50",
        "51", "52", "53", "54", "55", "56", "57", "58", "59"
      ],
    },
  });
  
  const emit = defineEmits(['update:modelValue']);
  
  const hour = ref('00');
  const minute = ref('00');

  const handleSelect = (event) => {
    let hourValue = props.modelValue?.split(':')[0] ?? "00";
    let minuteValue = props.modelValue?.split(':')[1] ?? "00";

    if (event.target.name === 'hour') {
        hourValue = event.target.value;
    } else {
        minuteValue = event.target.value;
    }
    
    hour.value = hourValue;
    minute.value = minuteValue;
    emit('update:modelValue', hourValue+':'+minuteValue);
  };

  onMounted(() => {
    let hourValue = props.modelValue?.split(':')[0] ?? "00";
    let minuteValue = props.modelValue?.split(':')[1] ?? "00";
    
    hour.value = hourValue;
    minute.value = minuteValue;
  });
  </script>
  
  <style>
  </style>
  